/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { QueryClient, QueryClientConfig } from "@tanstack/react-query";

const queryClientConfig = {
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			networkMode: "always"
		},
		mutations: { networkMode: "always" }
	}
} as QueryClientConfig;

class QueryClientStatic {
	private static instance: QueryClient;
	private constructor() {
		QueryClientStatic.instance = new QueryClient(queryClientConfig);
	}

	public static getInstance() {
		if (!QueryClientStatic.instance) {
			QueryClientStatic.instance = new QueryClient(queryClientConfig);
		}
		return QueryClientStatic.instance;
	}

	public static getQueryClient() {
		return this.getInstance();
	}
}

export default QueryClientStatic.getInstance();
